/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { OPEN_ICON_CONSTANTS } from './open-icon-constants';
export class OpenIconFoundation {
    constructor(_adapter) {
        this._adapter = _adapter;
        this._open = false;
        this._orientation = OPEN_ICON_CONSTANTS.strings.ORIENTATION_VERTICAL;
    }
    initialize() {
        this._adapter.setOrientation(this._orientation);
        this._adapter.setOpenState(this._open);
    }
    /** Controls the open state of the icon. */
    get open() {
        return this._open;
    }
    set open(value) {
        value = Boolean(value);
        if (this._open !== value) {
            this._open = value;
            this._adapter.setOpenState(this._open);
        }
    }
    get orientation() {
        return this._orientation;
    }
    set orientation(value) {
        this._orientation = value;
        this._adapter.setOrientation(this._orientation);
    }
}
